<script setup lang="ts">
import { formatCents } from '../composables/formatCents'
import type { ProductOwnerReviewCostPercentiles } from '../stores/product_owner_runs'

// Cost distribution over concluded runs' cost_cents (#1192) — the figure
// that showed the tail was unbounded in week one and motivated #1181's
// per-run cost ceiling. Every field is nil (rendered "—") when the window's
// cost sample is empty, not a row of misleading zeroes.
defineProps<{
  costPercentiles: ProductOwnerReviewCostPercentiles
}>()

function formatShare(share: number | null): string {
  return share == null ? '—' : `${share.toFixed(1)}%`
}
</script>

<template>
  <dl class="grid grid-cols-3 sm:grid-cols-7 gap-3 m-0" data-testid="product-owner-review-cost-distribution">
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">p50</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.p50) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">p75</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.p75) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">p90</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.p90) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">p95</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.p95) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">p99</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.p99) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">Max</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatCents(costPercentiles.max) }}</dd>
    </div>
    <div class="flex flex-col gap-0.5">
      <dt class="text-xs text-white/40">Top 5% of runs</dt>
      <dd class="m-0 text-sm text-white/80 tabular-nums">{{ formatShare(costPercentiles.top_5_percent_share) }}</dd>
    </div>
  </dl>
</template>
